module.exports = new __parcel__URL__("testimonial-gabriel.ad41ee07.webp").toString();